// src/services/AboutAndSustainabilityContentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  GET_PARTNERSHIP_CONTENT,
  UPDATE_PARTNERSHIP_CONTENT,
} from "../../config/constants"; // Adjust endpoints as per your config

const PartnershipContentService = createApi({
  reducerPath: "PartnershipContentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["PartnershipContent"],
  endpoints: (builder) => ({
    getPartnershipContentDetails: builder.query({
      query: (bodyData) => ({
        url: GET_PARTNERSHIP_CONTENT, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["PartnershipContent"],
    }),
    updatePartnershipContent: builder.mutation({
      query: ({ updatedData }) => ({
        url: `${UPDATE_PARTNERSHIP_CONTENT}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["PartnershipContent"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetPartnershipContentDetailsQuery,
  useUpdatePartnershipContentMutation,
} = PartnershipContentService;

// Export the reducer to be included in the store
export default PartnershipContentService;
